<template>
  <div class="brand-list-overlay">
    <div class="brand-list-container">
      <button class="close-btn" @click="$emit('close')">×</button>
      
      <div class="brand-list-content">
        <!-- Left: Floor Tabs -->
        <div class="floor-tabs">
          <div 
            v-for="floor in floors" 
            :key="floor" 
            class="floor-tab" 
            :class="{ active: activeFloor === floor }"
            @click="activeFloor = floor"
          >
            {{ floor }}
          </div>
        </div>
        
        <!-- Right: Brand Grid -->
        <div class="brand-grid-wrapper">
          <div class="brand-grid">
            <div 
              v-for="(brand, idx) in currentFloorBrands" 
              :key="idx" 
              class="brand-card" 
              @click="showBrandDetail(brand)"
            >
              <div class="brand-logo">
                <img v-if="brand.logo" :src="brand.logo" :alt="brand.name" @error="handleImageError">
                <span v-else class="logo-placeholder">{{ brand.name ? brand.name[0] : '' }}</span>
              </div>
              <div class="brand-name">{{ brand.name }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Brand Detail Modal -->
    <teleport to="body">
      <transition name="fade">
        <div v-if="selectedBrand" class="brand-modal-overlay" @click="selectedBrand = null">
          <div class="brand-modal" @click.stop>
            <button class="close-modal-btn" @click="selectedBrand = null">×</button>
            <div class="modal-header">
              <div class="modal-logo">
                 <img v-if="selectedBrand.logo" :src="selectedBrand.logo" :alt="selectedBrand.name" @error="handleImageError">
                 <span v-else class="logo-placeholder">{{ selectedBrand.name ? selectedBrand.name[0] : '' }}</span>
              </div>
              <div class="modal-title">
                <h2>{{ selectedBrand.name }}</h2>
                <span class="modal-floor">{{ selectedBrand.floor || activeFloor }}</span>
              </div>
            </div>
            <div class="modal-body">
              <p>{{ selectedBrand.description || selectedBrand.intro || '暂无介绍' }}</p>
              
              <!-- Goods List in Brand Detail -->
              <div v-if="selectedBrand.goods_list && selectedBrand.goods_list.length > 0" class="brand-goods-list">
                <div class="goods-title">商品推荐</div>
                <div class="goods-scroll">
                    <div v-for="(goods, gIdx) in selectedBrand.goods_list" :key="gIdx" class="goods-item" @click.stop="showProductDetail(goods)">
                        <div class="goods-img">
                            <img :src="goods.cover" :alt="goods.goods_name" @error="handleImageError">
                        </div>
                        <div class="goods-name">{{ goods.goods_name }}</div>
                        <div class="goods-price">¥{{ goods.price }}</div>
                    </div>
                </div>
              </div>
            </div>
            <div class="modal-footer">
              <button class="nav-btn" @click="startNavigation(selectedBrand)">
                <span class="icon">📍</span> 开始导航
              </button>
            </div>
          </div>
        </div>
      </transition>
    </teleport>

    <!-- Product Detail Modal -->
    <teleport to="body">
      <transition name="fade">
        <div v-if="selectedProduct" class="brand-modal-overlay" @click="selectedProduct = null">
          <div class="brand-modal product-modal" @click.stop>
            <button class="close-modal-btn" @click="selectedProduct = null">×</button>
            <div class="product-content">
              <div class="product-cover-large">
                <img :src="selectedProduct.cover" :alt="selectedProduct.goods_name" @error="handleImageError">
              </div>
              <div class="product-header">
                <h2 class="product-title">{{ selectedProduct.goods_name }}</h2>
                <div class="product-price-large">¥{{ selectedProduct.price }}</div>
              </div>
              <div class="product-desc">
                {{ selectedProduct.intro || '暂无商品介绍' }}
              </div>
            </div>
          </div>
        </div>
      </transition>
    </teleport>
  </div>
</template>

<script>
export default {
  name: 'BrandList',
  emits: ['close', 'navigate'],
  data() {
    return {
      activeFloor: '1F',
      floors: ['1F', '2F', '3F', '4F', '5F'],
      selectedBrand: null,
      selectedProduct: null,
      // Mock Data
      allBrands: {
        '1F': [
            { name: 'Starbucks', logo: 'https://img.icons8.com/color/144/starbucks.png', description: '星巴克咖啡公司成立于1971年，总部位于美国华盛顿州西雅图，致力于商业道德采购并烘焙世界上高品质的阿拉比卡咖啡。', map_floor: '1', map_x: '11791641.48', map_y: '3418859.50', goods_list: [{goods_name: '拿铁', price: 32, cover: 'https://images.unsplash.com/photo-1541167760496-1628856ab772?auto=format&fit=crop&w=300&q=80'}] },
            { name: 'Nike', logo: 'https://img.icons8.com/color/144/nike.png', description: 'NIKE公司总部位于美国俄勒冈州波特兰市。公司生产的体育用品包罗万象，例如服装，鞋类，运动器材等。', map_floor: '1', map_x: '11791550.00', map_y: '3418800.00', goods_list: [{goods_name: 'Air Jordan 1', price: 1299, cover: 'https://images.unsplash.com/photo-1513188732907-5f732b831ca2?auto=format&fit=crop&w=300&q=80'}] },
            { name: 'Apple', logo: 'https://img.icons8.com/ios-filled/144/mac-os.png', description: '苹果公司（Apple Inc.）是美国一家高科技公司。', map_floor: '1', map_x: '11791600.00', map_y: '3418820.00' },
            { name: 'Gucci', logo: 'https://img.icons8.com/color/144/gucci.png', description: 'Gucci，意大利时装品牌，由古驰奥·古驰在1921年于佛罗伦萨创办。', map_floor: '1', map_x: '11791620.00', map_y: '3418840.00' },
            { name: 'Dior', logo: 'https://upload.wikimedia.org/wikipedia/commons/thumb/a/a8/Dior_Logo.svg/1200px-Dior_Logo.svg.png', description: 'Dior是一个著名法国时尚消费品牌。', map_floor: '1', map_x: '11791650.00', map_y: '3418860.00' },
            { name: 'Lancome', description: '兰蔻1935年诞生于法国，是由Armand Petitjean（阿曼达·珀蒂让）创办的品牌。', map_floor: '1', map_x: '11791680.00', map_y: '3418880.00' },
            { name: 'Estee Lauder', description: '雅诗兰黛是美国雅诗兰黛公司旗下的化妆品旗舰品牌，以抗衰修护护肤品闻名。', map_floor: '1', map_x: '11791700.00', map_y: '3418900.00' },
        ],
        '2F': [
            { name: 'Zara', logo: 'https://upload.wikimedia.org/wikipedia/commons/thumb/f/fd/Zara_Logo.svg/800px-Zara_Logo.svg.png', description: 'ZARA是1975年设立于西班牙隶属Inditex集团(股票代码ITX)旗下的一个子公司，既是服装品牌也是专营ZARA品牌服装的连锁零售品牌。', map_floor: '2', map_x: '11791600.00', map_y: '3418800.00' },
            { name: 'H&M', logo: 'https://upload.wikimedia.org/wikipedia/commons/thumb/5/53/H%26M-Logo.svg/1200px-H%26M-Logo.svg.png', description: 'H&M于1947年由Erling Persson在瑞典Västerås市创立。', map_floor: '2', map_x: '11791650.00', map_y: '3418850.00' },
            { name: 'Uniqlo', logo: 'https://upload.wikimedia.org/wikipedia/commons/thumb/9/92/UNIQLO_logo.svg/1024px-UNIQLO_logo.svg.png', description: 'UNIQLO（优衣库）是日本服装品牌，由日本迅销公司建立于1963年。', map_floor: '2', map_x: '11791700.00', map_y: '3418900.00' },
            { name: 'Vero Moda', description: 'VERO MODA是丹麦最大时装集团BESTSELLER旗下的知名女装品牌。', map_floor: '2', map_x: '11791750.00', map_y: '3418950.00' },
            { name: 'Only', description: 'ONLY是丹麦著名的国际时装公司BESTSELLER拥有的众多著名品牌之一。', map_floor: '2', map_x: '11791800.00', map_y: '3419000.00' },
        ],
        '3F': [
            { name: 'Adidas', logo: 'https://img.icons8.com/color/144/adidas-trefoil.png', description: 'adidas（阿迪达斯）创办于1949年，是德国运动用品制造商阿迪达斯AG成员公司。', map_floor: '3', map_x: '11791600.00', map_y: '3418800.00' },
            { name: 'Puma', logo: 'https://img.icons8.com/color/144/puma.png', description: 'PUMA（彪马）是德国运动品牌，提出全新品牌口号Forever Faster，设计提供专业运动装备，产品涉及跑步、足球、高尔夫乃至赛车领域。', map_floor: '3', map_x: '11791650.00', map_y: '3418850.00' },
            { name: 'Li-Ning', description: '李宁公司是中国家喻户晓的"体操王子"李宁先生在1990年创立的体育用品公司。', map_floor: '3', map_x: '11791700.00', map_y: '3418900.00' },
            { name: 'Anta', description: '安踏体育用品有限公司 (Anta Sports Products Limited)，简称安踏体育、安踏，是中国一家知名的品牌体育用品企业。', map_floor: '3', map_x: '11791750.00', map_y: '3418950.00' },
        ],
        '4F': [
            { name: '海底捞', description: '海底捞品牌创建于1994年，历经二十多年的发展，海底捞国际控股有限公司已经成长为国际知名的餐饮企业。', map_floor: '4', map_x: '11791600.00', map_y: '3418800.00', goods_list: [{goods_name: '招牌虾滑', price: 48, cover: 'https://images.unsplash.com/photo-1555126634-323283e090fa?auto=format&fit=crop&w=300&q=80'}] },
            { name: '西贝莜面村', description: '西贝餐饮管理有限公司发源于内蒙古临河市，创业于1988年。', map_floor: '4', map_x: '11791650.00', map_y: '3418850.00' },
            { name: '外婆家', description: '外婆家餐饮连锁机构在发展的16年中，已开创有“外婆家”、“指福门”、“速堡”、“第二乐章”、“运动·会”五大知名中餐品牌。', map_floor: '4', map_x: '11791700.00', map_y: '3418900.00' },
            { name: '必胜客', description: '必胜客是比萨专卖连锁企业之一，由法兰克·卡尼和丹·卡尼数兄弟于1958年，凭着15美元的资金，在美国堪萨斯州威奇托创立。', map_floor: '4', map_x: '11791750.00', map_y: '3418950.00' },
        ],
        '5F': [
            { name: 'IMAX Cinema', description: 'IMAX影院，提供极致观影体验。', map_floor: '5', map_x: '11791600.00', map_y: '3418800.00' },
            { name: 'KTV', description: '豪华KTV包厢，顶级音响设备。', map_floor: '5', map_x: '11791650.00', map_y: '3418850.00' },
            { name: 'Gym', description: '高端健身房，配备游泳池。', map_floor: '5', map_x: '11791700.00', map_y: '3418900.00' },
        ]
      }
    }
  },
  computed: {
    currentFloorBrands() {
      return this.allBrands[this.activeFloor] || [];
    }
  },
  methods: {
    showBrandDetail(brand) {
      this.selectedBrand = brand;
    },
    showProductDetail(goods) {
      this.selectedProduct = goods;
    },
    startNavigation(brand) {
      this.$emit('navigate', {
        name: brand.name,
        floor_id: parseInt(brand.map_floor),
        x: parseFloat(brand.map_x),
        y: parseFloat(brand.map_y)
      });
      this.selectedBrand = null;
      this.$emit('close');
    },
    handleImageError(e) {
      e.target.style.display = 'none';
    }
  }
}
</script>

<style scoped>
.brand-list-overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(255, 255, 255, 0.95);
  z-index: 200; /* Higher than normal panels but lower than modals */
  display: flex;
  justify-content: center;
  align-items: center;
  backdrop-filter: blur(5px);
}

.brand-list-container {
  width: 90%;
  height: 90%;
  background: #fff;
  border-radius: 20px;
  box-shadow: 0 10px 40px rgba(0,0,0,0.1);
  display: flex;
  flex-direction: column;
  position: relative;
  overflow: hidden;
  border: 1px solid #eee;
}

.close-btn {
  position: absolute;
  top: 15px;
  right: 20px;
  font-size: 2rem;
  background: none;
  border: none;
  cursor: pointer;
  color: #999;
  z-index: 10;
  line-height: 1;
}

.brand-list-content {
  display: flex;
  height: 100%;
}

/* Left Tabs */
.floor-tabs {
  width: 80px;
  background: #f8f9fa;
  display: flex;
  flex-direction: column;
  border-right: 1px solid #eee;
  padding-top: 20px;
}

.floor-tab {
  padding: 20px 0;
  text-align: center;
  font-size: 1.1rem;
  font-weight: bold;
  color: #666;
  cursor: pointer;
  transition: all 0.3s;
  position: relative;
}

.floor-tab.active {
  background: #fff;
  color: #d14d5e;
}

.floor-tab.active::before {
  content: '';
  position: absolute;
  left: 0;
  top: 0;
  bottom: 0;
  width: 4px;
  background: #d14d5e;
}

.floor-tab:hover:not(.active) {
  background: #f0f0f0;
}

/* Right Grid */
.brand-grid-wrapper {
  flex: 1;
  padding: 30px;
  overflow-y: auto;
}

.brand-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(140px, 1fr));
  gap: 20px;
}

.brand-card {
  background: #fff;
  border: 1px solid #eee;
  border-radius: 12px;
  padding: 15px;
  display: flex;
  flex-direction: column;
  align-items: center;
  cursor: pointer;
  transition: transform 0.2s, box-shadow 0.2s;
}

.brand-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 5px 15px rgba(0,0,0,0.08);
  border-color: #d14d5e;
}

.brand-logo {
  width: 80px;
  height: 80px;
  border-radius: 50%;
  background: #f8f8f8;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 10px;
  overflow: hidden;
  border: 1px solid #f0f0f0;
}

.brand-logo img {
  width: 80%;
  height: 80%;
  object-fit: contain;
}

.logo-placeholder {
  font-size: 2rem;
  color: #d14d5e;
  font-weight: bold;
}

.brand-name {
  font-size: 0.9rem;
  font-weight: bold;
  color: #333;
  text-align: center;
  line-height: 1.3;
}

/* Modal Styles - Reused */
.brand-modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background: rgba(0,0,0,0.5);
  z-index: 9999;
  display: flex;
  justify-content: center;
  align-items: center;
  backdrop-filter: blur(2px);
}

.brand-modal {
  width: 80%;
  max-width: 400px;
  background: #fff;
  border-radius: 1.5vh;
  padding: 2vh;
  position: relative;
  box-shadow: 0 10px 30px rgba(0,0,0,0.2);
  animation: modal-pop 0.3s cubic-bezier(0.34, 1.56, 0.64, 1);
}

@keyframes modal-pop {
  from { transform: scale(0.8); opacity: 0; }
  to { transform: scale(1); opacity: 1; }
}

.close-modal-btn {
  position: absolute;
  top: 1vh;
  right: 1vh;
  background: none;
  border: none;
  font-size: 1.5rem;
  color: #999;
  cursor: pointer;
  line-height: 1;
  padding: 0.5vh;
  z-index: 2;
}

.modal-header {
  display: flex;
  align-items: center;
  margin-bottom: 2vh;
}

.modal-logo {
  width: 6vh;
  height: 6vh;
  border-radius: 1vh;
  background: #f8f8f8;
  overflow: hidden;
  margin-right: 1.5vh;
  display: flex;
  justify-content: center;
  align-items: center;
  border: 1px solid #eee;
  flex-shrink: 0;
}

.modal-logo img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.modal-title h2 {
  margin: 0;
  font-size: 1.1rem;
  color: #333;
}

.modal-floor {
  font-size: 0.8rem;
  color: #999;
  display: inline-block;
  background: #f0f2f5;
  padding: 0.2vh 0.8vh;
  border-radius: 0.4vh;
  margin-top: 0.5vh;
}

.modal-body {
  margin-bottom: 2.5vh;
  font-size: 0.9rem;
  color: #666;
  line-height: 1.6;
  max-height: 40vh; /* Increased for brand list */
  overflow-y: auto;
}

.modal-footer {
  display: flex;
  justify-content: center;
}

.nav-btn {
  background: linear-gradient(135deg, #d14d5e 0%, #d65db1 100%);
  color: #fff;
  border: none;
  padding: 1.5vh 4vh;
  border-radius: 3vh;
  font-size: 1rem;
  font-weight: bold;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.8vh;
  box-shadow: 0 4px 12px rgba(209, 77, 94, 0.3);
  width: 80%;
}

.brand-goods-list {
  margin-top: 20px;
  border-top: 1px dashed #eee;
  padding-top: 10px;
}

.goods-title {
  font-weight: bold;
  color: #333;
  margin-bottom: 10px;
}

.goods-scroll {
  display: flex;
  gap: 10px;
  overflow-x: auto;
  padding-bottom: 5px;
}

.goods-item {
  width: 80px;
  flex-shrink: 0;
  cursor: pointer;
}

.goods-img {
  width: 80px;
  height: 80px;
  border-radius: 8px;
  overflow: hidden;
  background: #f8f8f8;
  margin-bottom: 5px;
}

.goods-img img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.goods-name {
  font-size: 12px;
  color: #333;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.goods-price {
  font-size: 12px;
  color: #d14d5e;
  font-weight: bold;
}

/* Product Modal Specifics */
.product-content {
  display: flex;
  flex-direction: column;
  gap: 1.5vh;
}

.product-cover-large {
  width: 100%;
  aspect-ratio: 16/9;
  border-radius: 1vh;
  overflow: hidden;
  background: #f8f8f8;
}

.product-cover-large img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.product-header {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
}

.product-title {
  font-size: 1.1rem;
  font-weight: bold;
  color: #333;
  margin: 0;
  flex: 1;
}

.product-price-large {
  font-size: 1.2rem;
  color: #d14d5e;
  font-weight: bold;
  margin-left: 1vh;
}

.product-desc {
  font-size: 0.9rem;
  color: #666;
  line-height: 1.5;
  max-height: 15vh;
  overflow-y: auto;
}
</style>